import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

export const Slide3 = ({ t, total, onActive }) => {
  return (
    <SlideShell theme="emissor"
      index={2}
      total={total}
      label="Why Now"
      kicker={t.kicker}
      onActive={onActive}
      variant="plain"
      bgStyle={{
        "--slide-bg": "linear-gradient(115deg,#020202,#0b120e),radial-gradient(900px 660px at 20% 60%,rgba(216,182,46,.22),transparent 70%)"
      }}
    >

      <h2>{t.title}</h2>
      
      <p className="lead">{t.body}</p>
      
      <div className="grid four wide">
        <div className="card">
          <span className="num">{t.c1Num}</span>
          <h3>{t.c1Title}</h3>
          <p>{t.c1Body}</p>
        </div>
        <div className="card">
          <span className="num">{t.c2Num}</span>
          <h3>{t.c2Title}</h3>
          <p>{t.c2Body}</p>
        </div>
        <div className="card">
          <span className="num">{t.c3Num}</span>
          <h3>{t.c3Title}</h3>
          <p>{t.c3Body}</p>
        </div>
        <div className="card">
          <span className="num">{t.c4Num}</span>
          <h3>{t.c4Title}</h3>
          <p>{t.c4Body}</p>
        </div>
      </div>
    </SlideShell>
  );
};


